import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import './ChangePassword.css';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters long');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const user = JSON.parse(sessionStorage.getItem('user2'));
      
      const response = await axios.post(
        'https://api.assetview.warrantyindia.com/api/auth/change-password',
        {
          username: user?.username,
          oldPassword: oldPassword,
          newPassword: newPassword
        }
      );

      if (response.data.ok) {
        setMessage('✅ Password changed successfully!');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        
        // Redirect after 2 seconds
        setTimeout(() => {
          navigate('/employeesearch');
        }, 2000);
      } else {
        setError(response.data.error || 'Failed to change password');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="change-password-page">
      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col md={6} lg={5} xl={4} style={{ width: '100%' }}>
            <Card className="change-password-card shadow-lg border-0">
              <Card.Header className="change-password-header py-4 text-center">
                <div className="header-icon mb-2">
                  <i className="fa-solid fa-key"></i>
                </div>
                <h3 className="mb-0">Change Password</h3>
                <p className="text-muted small mt-1">Update your account password</p>
              </Card.Header>
              <Card.Body className="p-4">
                {message && (
                  <Alert variant="success" className="alert-fade-in">
                    {message}
                  </Alert>
                )}
                {error && (
                  <Alert variant="danger" className="alert-fade-in">
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="fa-solid fa-lock me-2"></i>
                      Current Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      placeholder="Enter your current password"
                      className="form-control-lg"
                      disabled={isLoading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="fa-solid fa-key me-2"></i>
                      New Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="Enter new password (min 6 characters)"
                      className="form-control-lg"
                      disabled={isLoading}
                    />
                    <Form.Text className="text-muted">
                      Password must be at least 6 characters long
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">
                      <i className="fa-solid fa-check-circle me-2"></i>
                      Confirm New Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm your new password"
                      className="form-control-lg"
                      disabled={isLoading}
                    />
                  </Form.Group>

                  <div className="d-grid gap-2">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      size="lg"
                      disabled={isLoading}
                      className="change-password-btn"
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        <>
                          <i className="fa-solid fa-save me-2"></i>
                          Update Password
                        </>
                      )}
                    </Button>
                    <Button 
                      variant="outline-secondary" 
                      onClick={() => navigate(-1)}
                      disabled={isLoading}
                    >
                      <i className="fa-solid fa-arrow-left me-2"></i>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePassword;